import LoadingImage from "Assets/Images/loading-purple.gif";
import { TableItem } from "./TableItem";

interface TableItemsProps {
  imported_orders: any[];
  loading: boolean;
}

export const TableItems = ({ imported_orders, loading }: TableItemsProps) => {
  function Loading() {
    return (
      <span className="loading-persons">
        <img src={LoadingImage} alt="" />
      </span>
    );
  }

  return (
    <table className="table-content small-separate details">
      <thead>
        <tr>
          <th>Código</th>
          <th>Status</th>
          <th>Data</th>
          <th>Nº Registros</th>
          {/* <th>Nº Registros com falha</th> */}
        </tr>
      </thead>
      <tbody>
        {imported_orders.length > 0 && !loading ? (
          imported_orders.map((item: any) => (
            <TableItem key={item.id} item={item} />
          ))
        ) : (
          <tr>
            <td className="text-center text-purple">
              {loading ? (
                <Loading />
              ) : (
                "Oops! Parece que nada foi encontrado..."
              )}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
